import React, { Component } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, Modal, Checkbox } from 'react-bootstrap';
import { connect } from 'react-redux';

import OverlayLoader from '../components/overlayLoader';
import { showModalMessage } from '../store/modalsSlice';

import * as accountsActions from '../store/accountsSlice';
import { accountsSelectors } from '../store/accountsSlice';
import { unwrapResult } from '@reduxjs/toolkit';

const Mode = {
  Create: 0,
  Edit: 1
};

const Titles = {
  [Mode.Create]: "Create new ai account",
  [Mode.Edit]: "Edit ai account"
};

const SubmitButtonCaptions = {
  [Mode.Create]: "Create",
  [Mode.Edit]: "Save"
};

class AccountEditDialog extends Component {
  initState = {
    login: null,
    password: null,
    isSuper: false,
    selectedProviderId: '',
  };
  
  constructor(props) {
    super(props);
    this.handleClose = this.props.onClose;

    this.state = this.initState;

    this.onShow = this.onShow.bind(this);
    this.onClose = this.onClose.bind(this);

    this.onLoginChanged = this.onLoginChanged.bind(this);
    this.onPasswordChanged = this.onPasswordChanged.bind(this);
    this.onIsSuperChanged = this.onIsSuperChanged.bind(this);
    this.onSelectedProviderChanged = this.onSelectedProviderChanged.bind(this);

    this.onSubmit = this.onSubmit.bind(this);
  }

  static get Mode() {
    return Mode;
  }

  onShow() {
    this.setState(this.initState);
  }

  onClose() {
    this.handleClose();
    this.setState(this.initState);
  }

  onLoginChanged(e) {
    this.setState({ login: e.target.value.length > 0 ? e.target.value : null });
  }

  onPasswordChanged(e) {
    this.setState({ password: e.target.value.length > 0 ? e.target.value : null });
  }

  onIsSuperChanged(checked) {
    this.setState({ isSuper: checked });
  }

  onSelectedProviderChanged = (e) => {
    const { value: id } = e.target;
    this.setState({ selectedProviderId: id });
  };

  isSelectedProviderDisabled = () => {
    return this.props.providersState.isFetching;
  };

  isLoading = () => this.props.isAccountCreating;

  getLoaderMessage() {
    if (this.props.isAccountCreating) {
      return "Account creating...";
    }
    
  }

  isSubmitButtonDisabled() {
    return this.isLoading() ||
      this.state.login === null ||
      this.state.login.length === 0 ||
      this.state.password === null ||
      this.state.password.length === 0 ||
      this.state.selectedProviderId === '';
  }

  onSubmit() {
    this.onClose();
    let submitPromise;
    const { login, password, isSuper, selectedProviderId } = this.state;

    submitPromise = this.props.addAccount({
      login, password, isSuper, providerId: selectedProviderId
    });

    if (submitPromise == null) {
      this.props.showModalMessage('Error', 'Unknown dialog mode');
      return;
    }

    submitPromise
      .then(unwrapResult)
      .catch((e) => {
        console.log(e);
        console.log(this.props.onSubmitError);
        this.props.showModalMessage("Error", this.props.onSubmitError.toString());
      });
  }

  render() {
    return (
      <Modal bsSize="small" show={this.props.show} onShow={this.onShow} onHide={this.onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>{Titles[this.props.mode]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OverlayLoader active={this.isLoading()} text={this.getLoaderMessage()}>
            <FormGroup controlId="fcLogin">
              <ControlLabel>Login</ControlLabel>
              <FormControl value={this.state.login} onChange={this.onLoginChanged} type="text" />
            </FormGroup>
            <FormGroup controlId="fcPassword">
              <ControlLabel>Password</ControlLabel>
              <FormControl value={this.state.password} onChange={this.onPasswordChanged} type="text" />
            </FormGroup>
            <FormGroup controlId="fcSuperAccount" disabled>
              <Checkbox
                onChange={e => this.onIsSuperChanged(e.target.checked)}
                checked={this.state.isSuper}
              >
                Super account
              </Checkbox>
            </FormGroup>
            <FormGroup controlId="fcLProvider">
                <ControlLabel>AI Provider</ControlLabel>
                <FormControl
                  componentClass="select"
                  placeholder="AI provider"
                  value={this.state.selectedProviderId}
                  onChange={this.onSelectedProviderChanged}
                  disabled={this.isSelectedProviderDisabled()}
                >
                  <option value='' disabled>Select provider...</option>
                  {this.props.providersState.data.map(provider => {
                    return (
                      <option key={provider.id} value={provider.id}>{provider.name}</option>
                    );
                  })}
                </FormControl>
              </FormGroup>
          </OverlayLoader>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onSubmit} disabled={this.isSubmitButtonDisabled()}>
            {SubmitButtonCaptions[this.props.mode]}
          </Button>
          <Button onClick={this.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
};

const mapStateToProps = state => ({
  isAccountCreating: accountsSelectors.state(state).isCreating,
  onSubmitError: accountsSelectors.state(state).creatingUpdatingError,
});

const actionCreators = {
  addAccount: accountsActions.create,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(AccountEditDialog);



// WEBPACK FOOTER //
// ./src/containers/accountEditDialog.js